import { z } from 'zod';
/**
 * Driver-scoped favourites shape shared between the PWA and the API.
 *
 * `FavoriteStation` is a denormalised row ready for a card render — the
 * server joins the user's favorite_station_ids against the Location
 * collection and flattens the result so the client never has to chase
 * nested data.
 */
export const FavoriteStationOpenStatusSchema = z.enum(['open_24_7', 'open_now', 'closed']);
export const FavoriteStationSchema = z.object({
    id: z.string(),
    name: z.string(),
    /** Street + city + state on one line, pre-formatted. */
    address: z.string(),
    /** Optional eyebrow caption (e.g. "DOWNTOWN"). */
    subtitle: z.string().optional(),
    /** Hero photo URL. May be absent until brand imagery ships. */
    photoUrl: z.string().optional(),
    stallsAvailable: z.number().int().nonnegative(),
    stallsTotal: z.number().int().nonnegative(),
    openStatus: FavoriteStationOpenStatusSchema,
    /** ISO timestamp of when the driver favourited this station. */
    favoritedAt: z.string(),
});
export const FavoritesListSchema = z.object({
    favorites: z.array(FavoriteStationSchema),
});
export const FavoriteToggleResponseSchema = z.object({
    favorited: z.boolean(),
    totalCount: z.number().int().nonnegative(),
});
export const FavoriteCheckResponseSchema = z.object({
    favorited: z.boolean(),
});
//# sourceMappingURL=favorites.js.map